module.exports = __webpack_public_path__ + "img/open-credit-card-title.cf79ae0a.png";